import { PHASES_LIST } from "@/assets/constants/selectsLists";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { usePhase } from "@/store/usePhase";
import { useMemo, type FC } from "react";
import ButtonClosePhase from "./ButtonClosePhase";
import { useLanguage } from "@/context/language-context/LanguageContext";

interface CanPhaseCloseProps {
  askCloseInspection: () => void;
  closeInspectionPhase: (phaseId: number) => void;
}

const CanPhaseClose: FC<CanPhaseCloseProps> = ({
  askCloseInspection,
  closeInspectionPhase,
}) => {
  const translate = useTranslate();
  const { language } = useLanguage();

  const { tasks, completed, phaseLabel, currentPhase } = usePhase();

  const endPhaseConfig = useMemo(() => {
    if (!currentPhase) return null;
    if (tasks && completed && tasks === completed) {
      let nextPhase = "";
      if (currentPhase < 4) {
        const nextPhaseId = currentPhase + 1;
        nextPhase = PHASES_LIST.find((it) => it.id === nextPhaseId)?.name || "";
      }
      return {
        title: translate("phaseHasCompleted", [translate(phaseLabel)]),
        description:
          currentPhase < 4
            ? translate("closeCurrentPhase", [translate(nextPhase)])
            : translate("allPhasesCompleted"),
        buttonLabel:
          currentPhase < 4
            ? translate("closePhase", [translate(phaseLabel)])
            : translate("endInspection"),
      };
    }
    return null;
  }, [tasks, completed, phaseLabel, currentPhase, language]);

  if (!endPhaseConfig) {
    return null;
  }
  return (
    <div className="px-4 md:px-14 pt-4 ">
      <ButtonClosePhase
        title={endPhaseConfig.title}
        description={endPhaseConfig.description}
        buttonLabel={endPhaseConfig.buttonLabel}
        onClick={currentPhase === 4 ? askCloseInspection : closeInspectionPhase}
      />
    </div>
  );
};

export default CanPhaseClose;
